import actions from './actions';

const {
	
	CREATE_BEGIN,
	CREATE_SUCCESS,
	CREATE_ERR,

	FETCH_DETAIL_BEGIN,
	FETCH_DETAIL_SUCCESS,
	FETCH_DETAIL_ERR,

	FETCH_LIST_BEGIN,
	FETCH_LIST_SUCCESS,
	FETCH_LIST_ERR,

	UPDATE_BEGIN,
	UPDATE_SUCCESS,
	UPDATE_ERR,

} = actions;

const initialStateFilter = {
	data: null,
	loading: false,
	error: null,
	detail: null,
	list: null,
};

const pickupReducer = (state = initialStateFilter, action) => {
	const { type, data, err } = action;
	switch (type) {

		case CREATE_BEGIN:
			return {
				loading: true,
				error: null,
			};
		case CREATE_SUCCESS:
			return {
				loading: false,
				error: null,
			};
		case CREATE_ERR:
			return {
				loading: false,
				error: err,
			};

		case FETCH_DETAIL_BEGIN:
			return {
				loading: true,
				error: null,
				detail: null,
			};
		case FETCH_DETAIL_SUCCESS:
			return {
				loading: false,
				error: null,
				detail: data,
			};
		case FETCH_DETAIL_ERR:
			return {
				loading: false,
				error: err,
				detail: null,
			};

		case FETCH_LIST_BEGIN:
			return {
				loading: true,
				error: null,
				list: null,
			};
		case FETCH_LIST_SUCCESS:
			return {
				loading: false,
				error: null,
				list: data,
			};
		case FETCH_LIST_ERR:
			return {
				loading: false,
				error: err,
				list: null,
			};

		case UPDATE_BEGIN:
			return {
				loading: true,
				error: null,
			};
		case UPDATE_SUCCESS:
			return {
				loading: false,
				error: null,
			};
		case UPDATE_ERR:
			return {
				loading: false,
				error: err,
			};

		default:
			return state;
	}
};

export default pickupReducer;
